import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import {keepChk} from "../../../static/js/Common";
import {useShopAdminDetail2} from "../../../static/js/hock/shopHock";
import {openPopup} from "../../../static/js/Common2";
import UserPopupV2 from "./UserPopupV2";
import shopModiBtn3 from "../../../static/image/v2/shop/shopModiBtn3.png";
import {telFormat} from "../../../static/js/service/formatService";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {subNavEvent} from "../../../static/js/service/commonService";

export default function UserV2() {
  let [shopList] = useState([]);
  let [loginId, setLoginId] = useState("");
  let [name, setName] = useState("");
  let [tel, setTel] = useState("");
  let [email, setEmail] = useState("");

  // 세션 정보 조회
  const getKeepChk = keepChk();
  const userId = Number(getKeepChk[0].userId);

  useShopAdminDetail2({setLoginId, setName, setTel, setEmail}, userId);

  useEffect(() => {
    subNavEvent("manageNav", "manage3");
  }, []);

  return (
    <main id="ShopInfo1V2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <UserPopupV2 data={getKeepChk} loginId={loginId} />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="운영 관리" title2="계정 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="계정 관리" countText="" count="" unit="" />
          </div>
          <div id="shopSelectBox" className="hide">
            <ShopSelectBoxV2 />
          </div>
          <div className="shopInfoBox">
            <table className="shopInfoTable">
              <thead></thead>
              <tbody>
              <tr>
                <th>아이디</th>
                <td>{loginId}</td>
              </tr>
              <tr>
                <th>비밀번호</th>
                <td>
                  <div className="flexTd">
                    <div>-</div>
                    <button className="ediBtn openBtn" onClick={() => openPopup("userPopup")}>
                      <img src={ shopModiBtn3 } alt="수정" />
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <th>대표자 이름</th>
                <td>{name}</td>
              </tr>
              <tr>
                <th>대표자 연락처</th>
                <td>{telFormat(tel)}</td>
              </tr>
              <tr>
                <th>대표자 이메일</th>
                <td>{email}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  )
}